import React from 'react'

class InstrumentPlanDiv extends React.Component {
    state = {
        id: this.props.id || 0,
        instrumentID: this.props.instrumentID || 0,
        planName: this.props.planName || '',
        readOnly: this.props.readOnly || false,
    }

    componentDidMount = () => {
        this.doGetInstrumentPlan()
    }

    doGetInstrumentPlan = () => {
        const { id, instrumentID, planName } = this.state
        Tyan.doPostEvent('GetInstrumentPlan', {
            data: { id, instrumentID, planName },
            onEnd: ({ errorMessage, optionsParas, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    this.setState({ optionsParas, initValues基本信息, changedValues基本信息: {} })
                }
            }
        })
    }

    handlerSave = () => {
        const { onClose, onRefresh } = this.props
        const { id, instrumentID, planName } = this.state
        Tyan.doPostEvent('SaveInstrumentPlan', {
            data: { instrumentID, planName, ...Tyan.utility.getChangedFieldsets(this, '基本信息', false) },
            onEnd: ({ errorMessage, id }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    Ext.toast('保存成功')
                    onClose && onClose()
                    onRefresh && onRefresh()
                }
            }
        })
    }

    handlerDelete = () => {
        const { onClose, onRefresh } = this.props
        const { id } = this.state
        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent('DelInstrumentPlan', {
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    } else {
                        Ext.toast('删除成功')
                        onRefresh && onRefresh()
                        onClose && onClose()
                    }
                }
            })
        )
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }


    canSave = () => {
        const nullDate = Tyan.utility.nullDate
        const 设备 = Tyan.utility.getFormValue(this, '基本信息', '设备')
        const 计划类型 = Tyan.utility.getFormValue(this, '基本信息', '计划类型')
        const 操作参数 = Tyan.utility.getFormValue(this, '基本信息', '操作参数')
        const 开始时间 = Tyan.utility.getFormValue(this, '基本信息', '开始时间')
        const 结束时间 = Tyan.utility.getFormValue(this, '基本信息', '结束时间')

        var bOK = false
        if (['启用', '停用', '报废'].includes(计划类型)) {
            bOK = Tyan.utility.getFormValue(this, '基本信息', '负责人') && 开始时间 && 开始时间 > nullDate
        } else {
            var bPara = false
            if (['计量', '期间核查'].includes(计划类型)) {
                if (操作参数 && 操作参数.length > 0) {
                    for (var i = 0; i < 操作参数.length; i++) {
                        const v = Tyan.utility.getFormValue(this, '基本信息', 操作参数[i])
                        if (v == undefined || v == null || v == '') {
                            break
                        }
                        if (i === 操作参数.length - 1) {
                            bPara = true
                        }
                    }
                }
            } else {
                bPara = Tyan.utility.getFormValue(this, '基本信息', '保养类型') && 操作参数 && 操作参数.length > 0
            }
            bOK = (开始时间 && 结束时间 && 结束时间 >= 开始时间 > nullDate) && bPara && Tyan.utility.getFormValue(this, '基本信息', '执行人员')
        }

        return this.bChanged() && 设备 && 计划类型 && bOK
    }

    bChanged = () => {
        return Tyan.utility.hasChangedValues(this)
    }

    handleShowDetail = (id) => {
        Tyan.pubForm.showDialog("设备信息", props => <InstrumentDetail {...props} id={id} fatherID={0} readOnly={true} />)
    }

    handlerChange = (v, type) => {
        const 设备 = Tyan.utility.getFormValue(this, '基本信息', '设备')
        switch (type) {
            case '计划类型':
                const 保养类型 = Tyan.utility.getFormValue(this, '基本信息', '保养类型')
                Tyan.doPostEvent('GetRelationInfo', {
                    data: { type: '操作参数', objRelationInfo: { 设备, '计划类型': v, 保养类型 } },
                    onEnd: ({ errorMessage, optionsParas }) => {
                        if (optionsParas) {
                            Tyan.utility.changeItemsValue(this, '基本信息', ['操作参数'], [null])
                            this.setState({ optionsParas: { ...this.state.optionsParas, ...optionsParas } })
                        }
                    }
                })
                break
            case '保养类型':
                const 计划类型 = Tyan.utility.getFormValue(this, '基本信息', '计划类型')
                Tyan.doPostEvent('GetRelationInfo', {
                    data: { type: '操作参数', objRelationInfo: { 设备, 计划类型, '保养类型': v } },
                    onEnd: ({ errorMessage, optionsParas }) => {
                        if (optionsParas) {
                            Tyan.utility.changeItemsValue(this, '基本信息', ['操作参数'], [null])
                            this.setState({ optionsParas: { ...this.state.optionsParas, ...optionsParas } })
                        }
                    }
                })
                break
        }
    }

    fieldset基本信息 = () => {
        const i_设备 = Tyan.utility.getInitValue(this, '基本信息', '设备')
        const i_计划类型 = Tyan.utility.getInitValue(this, '基本信息', '计划类型')

        const 计划类型 = Tyan.utility.getFormValue(this, '基本信息', '计划类型')
        const 操作参数 = Tyan.utility.getFormValue(this, '基本信息', '操作参数')

        const b计量 = ['计量', '期间核查'].includes(计划类型)
        const b保养 = ['维护保养'].includes(计划类型)
        const b操作 = ['启用', '停用', '报废'].includes(计划类型)
        return [
            { _text: '设备编号/名称', name: '设备', disabled: true, cdt: () => i_设备 },
            { _select: '设备编号/名称', name: '设备', required: true, editable: true, forceSelection: false, onChange: (v) => console.log('v', v), cdt: () => !i_设备 },
            { _text: '计划类型', disabled: true, cdt: () => i_计划类型 },
            { _select: '计划类型', required: true, cdt: () => !i_计划类型, onChange: (v) => this.handlerChange(v, '计划类型') },
            { _select: '计量内容', name: '操作参数', required: true, multiSelect: true, cdt: () => b计量 },
            { _group: '技术要求', items: 操作参数 && 操作参数.map(o => ({ _text: o, required: true, maxRows: 3 })) || [], cdt: () => b计量 },
            { _select: '保养类型', required: true, cdt: () => b保养, onChange: (v) => this.handlerChange(v, '保养类型') },
            { _select: '保养内容', name: '操作参数', required: true, multiSelect: true, cdt: () => b保养 },
            { _select: '执行人员', required: true, cdt: () => !b操作 },
            { _date: '开始时间', required: true, cdt: () => !b操作 },
            { _date: '结束时间', required: true, cdt: () => !b操作 },

            { _text: '负责人', required: true, cdt: () => b操作 },
            { _date: '计划时间', name: '开始时间', required: true, cdt: () => b操作 },
            { _text: '原因', maxRows: 3, cdt: () => b操作 },
            { _text: '备注', maxRows: 3 },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { id, readOnly, initValues基本信息 } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />

        const { canEdit } = initValues基本信息
        return <Body data={this} maxWidth={600}
            controls={
                readOnly ? [{ _button: '关闭', handler: this.handlerClose }] :
                    [
                        { _button: '保存', handler: this.handlerSave, disabled: !this.canSave(), cdt: () => canEdit },
                        { _button: '删除', handler: this.handlerDelete, cdt: () => id > 0 && canEdit },
                        { _button: this.bChanged() && '取消' || '关闭', handler: this.handlerClose },
                    ]
            }
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: readOnly || !canEdit },
                ]}
        />
    }
}

export default InstrumentPlanDiv